// extracted by mini-css-extract-plugin
module.exports = {"Title":"Header_Title__3wbOp","Header":"Header_Header__3yweT"};